import React, {
  useContext,
  useEffect,
  useRef,
  useState,
  Suspense,
} from 'react';
import { Container, Col, Tabs, Tab } from 'react-bootstrap';
import _ from 'lodash';

import AppContext from '../../context';
import DashboardContainer from '../dashboard/dashboard.component';
const InvestmentContainer = React.lazy(() =>
  import('../investment/investment.container'),
);
import ManagePf from '../../presentational/manage_pf/manage_pf.component';
const EmptyPfs = React.lazy(() => import('./empty_pfs/empty_pfs.component'));
import Loader from '../../common/loader/loader.component';
import SyncBrokerMF from '../dashboard/sync_broker_or_mf/sync_broker_or_mf.component';
import './main.container.css';
import '../common.css';

const MainContainer = (props) => {
  const context = useContext(AppContext);
  //android, temp change
  const queryParams = new URLSearchParams(window.location.search);
  const isWebview = queryParams.get('user_agent') === 'webview';
  const disableAddTx = queryParams.get('update_txs') === 'disabled';
  const [tab, setTab] = useState(
    isWebview && queryParams.get('tab') === 'investment'
      ? 'investment'
      : 'dashboard',
  );
  const [isGoogleChart, setIsGoogleChart] = useState(false);
  //manage pf
  const [showManagePf, setShowManagePf] = useState(false);
  const [showImportMFs, setShowImportMFs] = useState(false);
  const [showSyncBrokerMF, setShowSyncBrokerMF] = useState(false);
  const currentPf = useRef(null);
  const [managePfFrom, setManagePfFrom] = useState(null); //create_pf,sync_from_summary

  const areAllPfsEmpty = () => {
    return !context.portfolios.some(
      (pf) => !pf.is_empty && pf.is_empty !== undefined,
    );
  };

  useEffect(() => {
    google.charts.setOnLoadCallback(() => {
      setIsGoogleChart(true);
    });
  }, []);

  return (
    <Container
      fluid
      className="main-container"
      style={isWebview ? { top: 0 } : {}}
    >
      {areAllPfsEmpty() ? (
        <Suspense fallback={<Loader isPageLoader={true} />}>
          <EmptyPfs setContext={props.setContext} />
        </Suspense>
      ) : (
        <Col>
          <Tabs
            id="main"
            activeKey={tab}
            onSelect={setTab}
            className={`page-tabs ${isWebview ? 'd-none' : ''}`}
            mountOnEnter={true}
          >
            <Tab eventKey="dashboard" title="Dashboard" className="tj-tab pb-2">
              <DashboardContainer
                setContext={props.setContext}
                setShowManagePf={setShowManagePf}
                setShowImportMFs={setShowImportMFs}
                setShowSyncBrokerMF={setShowSyncBrokerMF}
                setCurrentPf={(pf) => (currentPf.current = pf)}
                setManagePfFrom={setManagePfFrom}
              />
            </Tab>
            <Tab
              eventKey="investment"
              title="Investment"
              className="tj-tab pb-2"
            >
              {isGoogleChart ? (
                <Suspense fallback={<Loader isPageLoader={true} />}>
                  <InvestmentContainer />
                </Suspense>
              ) : (
                <span></span>
              )}
            </Tab>
          </Tabs>
          {!context.is_sample && !(isWebview && disableAddTx) && (
            <>
              <ManagePf
                show={showManagePf}
                setShow={setShowManagePf}
                showImportMFs={showImportMFs}
                setShowImportMFs={setShowImportMFs}
                setContext={props.setContext}
                currentPf={currentPf.current}
                managePfFrom={managePfFrom}
                setManagePfFrom={setManagePfFrom}
                resetCurrentPfRef={() => (currentPf.current = null)}
                setShowSyncBrokerMF={setShowSyncBrokerMF}
              />
            </>
          )}
          <SyncBrokerMF
            show={showSyncBrokerMF}
            setShow={setShowSyncBrokerMF}
            setShowImportMFs={setShowImportMFs}
            setShowManagePf={setShowManagePf}
            setManagePfFrom={setManagePfFrom}
          />
        </Col>
      )}
    </Container>
  );
};

export default MainContainer;
